/**
 * Remove trailing slash character of Url and return the rest
 * @param {String} url
 * @returns {String} url with out trailing slash
 */
export function removeUrlTrailingSlash(url: string) {
    return url && url.match(/.*\/$/) ? url.slice(0, -1) : url;
}
